// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__oHGRK","alertIcon":"ConfirmModal_alertIcon__CNNUR"};